class MonitorService {

    async getActivities (){
        const res =  await fetch ("/api/v1/monitor/activities", {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
            ,
            credentials: "same-origin"
        });
        const activities = await res.json();
        return activities;
    }

    async getPublicActivities (){
        const res =  await fetch ("/api/v1/monitor/publicActivities", {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
            ,
            credentials: "same-origin"
        });
        const publicActivities = await res.json();
        return publicActivities;
    }

    async getAccess (){
        const res =  await fetch ("/api/v1/monitor/logins", {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
            ,
            credentials: "same-origin"
        });
        const logins = await res.json();
        return logins;
    }
}

const monitorService = new MonitorService();
export default monitorService;